import {
  AppShell,
  Avatar,
  Badge,
  Box,
  Burger,
  Group,
  NavLink,
  ScrollArea,
  Tooltip,
  UnstyledButton
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconActivity,
  IconBuildingStore,
  IconChartBar,
  IconClipboardList,
  IconSettings,
  IconUsers
} from "@tabler/icons-react";
import { Link, Outlet, useLocation } from "react-router-dom";

interface NavItem {
  path: string;
  label: string;
  icon: React.FC<{ size?: number }>;
}

const navItems: NavItem[] = [
  { path: "/customers", label: "Customers", icon: IconBuildingStore },
  { path: "/analytics", label: "Analytics", icon: IconChartBar },
  { path: "/audit", label: "Audit log", icon: IconClipboardList },
  { path: "/team", label: "Team", icon: IconUsers },
  { path: "/webhooks", label: "Webhooks", icon: IconActivity },
  { path: "/settings", label: "Settings", icon: IconSettings }
];

export const OpsLayout = () => {
  const [mobileOpen, { toggle: toggleMobile }] = useDisclosure(false);
  const location = useLocation();

  return (
    <AppShell
      header={{ height: 56 }}
      navbar={{ width: 220, breakpoint: "sm", collapsed: { mobile: !mobileOpen } }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group gap="sm">
            <Burger opened={mobileOpen} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
            <Group gap={8} align="center">
              <img
                src="/logo-horizontal.svg"
                alt="Veritrellis"
                height={26}
                style={{ display: "block", width: "auto" }}
              />
              <Badge size="xs" variant="light" color="orange">
                ops
              </Badge>
            </Group>
          </Group>
          <UnstyledButton component={Link as React.ElementType} to="/settings">
            <Avatar size="sm" radius="xl" color="brand">
              V
            </Avatar>
          </UnstyledButton>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="xs">
        <ScrollArea flex={1}>
          {navItems.map((item) => {
            const active = location.pathname.startsWith(item.path);
            return (
              <Tooltip key={item.path} label={item.label} position="right" withArrow disabled>
                <NavLink
                  component={Link as React.ElementType}
                  to={item.path}
                  label={item.label}
                  leftSection={<item.icon size={16} />}
                  active={active}
                  variant="light"
                  mb={2}
                />
              </Tooltip>
            );
          })}
        </ScrollArea>
      </AppShell.Navbar>

      <AppShell.Main>
        <Box maw={1200} mx="auto">
          <Outlet />
        </Box>
      </AppShell.Main>
    </AppShell>
  );
};
